import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { Translate } from 'react-jhipster';
import { getProfesseur, deleteProfesseur } from './personnel.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PersonnelDeleteModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const professeur = useAppSelector(state => state.professeur.entity);
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getProfesseur(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/personnel/${currentEcole && currentEcole.id}`);
  };

  const confirmDelete = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
    };
    dispatch(deleteProfesseur(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {professeur.id !== null && (
        <Modal
          title="Confirmation de suppression"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
              Supprimer
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Etes-vous certain de vouloir supprimer {professeur.prenom} {professeur.nom} du personnel?
        </Modal>
      )}
    </>
  );
};

export default PersonnelDeleteModal;
